
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import TablePagination from "@material-ui/core/TablePagination";
import { Button } from "@material-ui/core";
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useHistory, useRouteMatch, useLocation, Link } from "react-router-dom";
import FilterListSharpIcon from "@material-ui/icons/FilterListSharp";
import {
  investmentDetailsPath,
  editInvestPath,
  handleSort,
  getDateTime,
  getDate, viewResearchReportsPath, ViewNestedChildMisReportsPath, viewMitsReportsPath
} from "../utils/varialbles";
import TableHead from "@material-ui/core/TableHead";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";

import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import http from "../services/reportsPath";
import SearchBar from "material-ui-search-bar";
import { SvgIcon, } from "@material-ui/core";
import useFilter from "../components/sideFilter";
import { ReactComponent as FilterLogo } from "../images/filter.svg";
// import filterData from "../components/filterCriteria";

import toast from "react-hot-toast";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";

import {
  MenuItem,
  Select,
  InputLabel,
  TextField,
  ListItemIcon,
  Checkbox,
  ListItemText,
  TableSortLabel
} from "@material-ui/core";

import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  tableRow: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  sticky: {
    position: "sticky",
    left: 0,
    background: "white",
    boxShadow: "0px 0px 1px grey",
    zIndex: 300,
  },
});


let uniqueApiNames = {};

function ViewChildMitReports() {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(
    localStorage.getItem("investmentrowsperpage") || "10"
  )
  const [rows, setRows] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");
  // const [anchorEl, setAnchorEl] = React.useState(true);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const location = useLocation();
  const myparam = location.state;

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isFilterData, setIsFilterData] = useState([]);
  const [appliedFilter, setAppliedFilter] = useState([]);
  const [isFilterString, setIsFilterString] = useState(
    localStorage.getItem("selectedinvestorfiltersdata") || ""
  )
  const [isRange, setIsRange] = React.useState(false);
  const [filterTrue, setFilterTrue] = useState(false);

  const receiveid = location.sendid;

  // (isFilterString,appliedFilter,isFilterData);


  const [isSelectedData, setIsSelectedDatas] = useState([
    {
      id: 1,
      data: { equalTo: "" },
      name: "First Investment Date",

    },
    {
      id: 2,
      options: [],
      name: "Country",

    },
    {
      id: 3,
      options: [],
      name: "Asset Class",
    },
    {
      id: 4,
      data: { equalTo: "" },
      name: 'Investment Amount',
    },
    {
      id: 5,
      data: { equalTo: "" },
      name: 'Advised Amount',
    },
    {
      id: 6,
      data: { equalTo: "" },
      name: 'Current Amount',
    },
    {
      id: 7,
      data: { equalTo: "" },
      name: 'Deviation',
    },
    {
      id: 8,
      data: { equalTo: "" },
      name: 'CAGR Return',
    },
    {
      id: 9,
      data: { equalTo: "" },
      name: 'Absolute Return',
    },
    {
      id: 10,
      data: { equalTo: "" },
      name: 'Portfolio Return',
    },
    {
      id: 11,
      data: { equalTo: "" },
      name: 'Market Performance',
    },
    {
      id: 12,
      data: { equalTo: "" },
      name: 'Alpha',
    },
  ])

  const [columns, setColumns] = useState([]);

  const [researchReportChild, setResearchReportChild] = useState([
    {
      headerName: "Country",
      id: "country",
      show: true,
      minWidth: 100,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "First Investment Date",
      id: "date",
      show: true,
      format: "Date",
      minWidth: 150,
      headerAlign: "left",
      align: "left",
      type: 'Date'
    },
    {
      headerName: "Security Name",
      id: "name",
      show: true,
      minWidth: 150,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Average Share Price",
      id: "avg",
      show: true,
      minWidth: 150,
      headerAlign: "right",
      align: "left",
    },
    {
      headerName: "Units",
      id: "qty",
      show: true,
      minWidth: 150,
      headerAlign: "right",
      align: "left",
    },
    {
      headerName: "Asset Class",
      id: "type",
      show: true,
      minWidth: 150,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Sub Asset Class",
      id: "sector",
      show: true,
      minWidth: 150,
      headerAlign: "left",
      align: "left",
    },

    {
      headerName: "Portfolio Investment Amount",
      id: "investedval",
      show: true,
      minWidth: 150,
      headerAlign: "left",
      align: "left",
    },

    {
      headerName: "Portfolio Advised Amount",
      id: "advisedval",
      show: true,
      minWidth: 150,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Deviation",
      id: "deviation",
      show: true,
      minWidth: 150,
      headerAlign: "left",
      align: "left",
    },

    {
      headerName: "Current Value",
      id: "currentval",
      show: true,
      minWidth: 150,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "CAGR Return",
      id: "cagr",
      show: true,
      minWidth: 150,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Portfolio Return",
      id: "gainper",
      show: true,
      minWidth: 150,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Market Return",
      id: "market",
      show: true,
      minWidth: 150,
      headerAlign: "left",
      align: "left",
    },

  ]);
  const [counter, setCounter] = useState(0);

  const [stockwiseMasterChild, setStockwiseMasterChild] = useState([
    {
      headerName: "Security Name",
      id: "security",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Asset Class",
      id: "asset_class",
      show: true,
      minWidth: 150,
      type: 'text'
    },
    {
      headerName: "Invested Date",
      id: "date",
      show: true,
      minWidth: 150,
      type: 'Date'
    },
    {
      headerName: "Client Name",
      id: "name",
      show: true,
      minWidth: 150,
      type: 'decimal'
    },
    {
      headerName: "Total Invested Amount",
      id: "invested",
      show: true,
      minWidth: 150,
      type: 'decimal'
    },
    {
      headerName: "Total Adviced Amount",
      id: "adviced",
      show: true,
      minWidth: 150,
      type: 'decimal'
    },
    {
      headerName: "Current Value",
      id: "currentval",
      show: true,
      minWidth: 150,
      type: 'decimal'
    },
    {
      headerName: "Return",
      id: "return",
      show: true,
      minWidth: 150,
      type: 'decimal'
    }
  ]);

  const [showApiData, setApiData] = useState([
    {
      id: 0,
      apiname: "research_child",
      columName: researchReportChild
    },
    {
      id: 1,
      apiname: "stockwise_child",
      columName: stockwiseMasterChild
    },
  ])


  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    variant: "menu",
  };

  // const [selected, setSelected] = useState([]);
  // (selected);


  useEffect(() => {
    setCounter(counter + 1);
    const uniqueColumns = showApiData.filter((ele) => {
      return ele.id === receiveid
    });
    setColumns(uniqueColumns[0].columName)

    uniqueApiNames = uniqueColumns[0];

    if (filterTrue === true) {
      setIsFilterString(getFilterParams());
    }

    let filtermatchString = getFilterParams();
    if (counter >= 2) {
      if (filtermatchString === isFilterString) {
        getData();
      }
    }

  }, [isFilterString, appliedFilter]);

  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("ticketFilter");

    getData();
  }, [page, rowsPerPage]);
  const getData = (newQuery) => {

    const baseURL = uniqueApiNames.apiname;
    setRows([]);

    // http.get(getPaginationURL(baseURL, newQuery) + filterString).then(res => {
    http
      .get(getPaginationURL(baseURL, newQuery) + isFilterString)
      .then((res) => {
        toast.dismiss();
        // (res.data.data);
        if (
          res &&
          res.data &&
          res.data.statusCode === 0 &&
          Array.isArray(res.data.data)
        ) {
          let tempDta = res.data.data;
          let overallData = res.data.overall_data;
          // setfilterMapping(res.data.filter);
          // (filterMapping, "filterData");
          // setOverAllData(overallData);
          //   let finalrows = tempDta.map((item) => {
          //     const obj = item;
          //     const swapValue = (obj) => {
          //       Object.keys(obj).forEach((key) => {});
          //     };
          //     swapValue(obj);
          //     return item;
          //   });

          const datas = res.data.filter;
          let rawData = datas.map((es, index) => {
            es.id = index + 1
            return es
          })
          setIsFilterData(rawData);
          setOriginalRows(tempDta);
          setRows(res.data.data);
          setTotalRowCount(res.data.totalRowCount);
        }
        else {
          setIsFilterData([]);
          setOriginalRows([]);
          setRows([]);
          setTotalRowCount(0);
        }
      })

  };


  const form = {
    Country: "",
    // EFG_Score: "",
    // EFG_Score__condition: "lte",
  };
  const [formObject, setFormObject] = React.useState(form);


  // const applyFilter = (e) => {
  //   let tempObject = { ...formObject };
  //   let tempORows = [...orignalRows];
  //   let filter = filterData(tempObject, tempORows, columns);
  //   setRows(filter);
  //   setPage(0);
  // };

  const handleMenuClose = () => {
    // ('closefunction')
    // setAnchorEl(false);
    setIsMenuOpen(false);
  };

  const openFilter = (e) => {
    // setIsMenuOpen(true);
    setIsFilterOpen(true)

    // let currentTarget = e.currentTarget;
    // setAnchorEl(currentTarget);
    // setAnchorEl(true);
  };
  const closeFilter = () => {
    setIsFilterOpen(false)
  }

  const handleChange = (e) => {
    setFormObject({
      ...formObject,
      [e.target.name]: e.target.value,
    });
  };

  const cancelSearch = (searchVal) => {
    setSearched(searchVal);
    let abc = "";
    // getData(abc)
  };
  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];
    // (searchedVal)
    setSearched(searchedVal);
    setPage(0)

  };
  const requestSearching = () => {
    if (searched === undefined || searched.length < 4) {
      toast.error("Please Enter more than 3 characters to search")
    }
    else {
      getData(searched)

    }
  }

  // useEffect(x=>{
  //     // (page, orignalRows);
  // }, [page, orignalRows]);

  let history = useHistory();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);

    setRows(finalRows);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  const viewProspectDetails = (object) => {

    object.page = page;

    history.push({
      pathname: ViewNestedChildMisReportsPath,
      // pathname: "viewmitsnestedchildreport",
      state: object,
      id: receiveid,
      asset_id: myparam.asset_id
    });

    // history.push(
    //     {
    //         pathname: viewMitsChildReportsPath,
    //         myparam: receiveid
    //     },
    //     (myparam)
    // );
  }

  // added the below line --step2
  const [Filter, filterString, passFilters, passData] = useFilter();

  const [totalRowCount, setTotalRowCount] = React.useState(0);

  const getPaginationURL = (url, newQuery) => {
    const query = newQuery === "" ? newQuery : searched;
    if (query) {
      return `${url}?page=${page + 1
        }&rowsPerPage=${rowsPerPage}&emp_id=${query}`;
    } else if (receiveid === 0) {
      return (
        `${url}/${myparam.cust_id}?`
      )
    } else if (receiveid === 1) {
      return `${url}?asset_id=${myparam.asset_id || location.asset_id}`;
    } else if (!query) {
      return (
        `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}`
      )
    }
  };


  // handle filter modal change
  const handleSelectChange = (v, id, meta) => {

    // ('am ', v, id);
    if (v === 'range') {
      setIsRange(true);
    } else {
      // setIsRange(false);
    }
    ;
    setIsSelectedDatas(fstate => {
      const newState = isFilterData.map(x => {

        if (x.id === id) {
          if (x.type === 'select') {
            return ({
              name: x.name,
              id: x.id,
              options: v,

            })
          } else if (x.type === 'radio') {
            return ({
              name: x.name,
              id: x.id,
              options: [v]
            })
          } else if (x.type === 'date' || x.type === 'number') {
            if (meta === 'option') {
              const fstateObject = fstate.find(filter => filter.id === x.id);
              let currentValue = fstateObject.data.lessThan ? fstateObject.data.lessThan : "";
              currentValue = fstateObject.data.greaterThan ? fstateObject.data.greaterThan : "";
              currentValue = fstateObject.data.equalTo ? fstateObject.data.equalTo : "";
              currentValue = fstateObject.data.greaterThanEqual ? fstateObject.data.greaterThanEqual : "";
              currentValue = fstateObject.data.lessThanEqual ? fstateObject.data.lessThanEqual : "";
              currentValue = fstateObject.data.range ? fstateObject.data.range : "";
              // (currentValue);
              return ({ id, name: x.name, data: { [v]: currentValue } })
            } else if (meta === 'value') {
              const fstateObject = fstate.find(filter => filter.id === x.id);
              const currentOption = Object.keys(fstateObject.data)[0];
              return ({ id, name: x.name, data: { [currentOption]: v } })
            } else if (meta === 'rangeFrom') {
              const fstateObject = fstate.find(filter => filter.id === x.id);
              const currentOption = Object.keys(fstateObject.data)[0];
              const currentValue = fstateObject.data[Object.keys(fstateObject.data)[0]];
              if (currentValue.includes(',')) {
                const fromValue = currentValue.split(',')[0];
                const toValue = currentValue.split(',')[1];
                const encodedDate = `${v},${toValue}`;
                // ({currentValue, v, fromValue, toValue, encodedDate});
                return ({ id, name: x.name, data: { [currentOption]: encodedDate } })
              } else {
                const encodedDate = `${v},`;
                // (currentValue, v, encodedDate)
                return ({ id, name: x.name, data: { [currentOption]: encodedDate } })
              }
            } else if (meta === 'rangeTo') {
              const fstateObject = fstate.find(filter => filter.id === x.id);
              const currentOption = Object.keys(fstateObject.data)[0];
              const currentValue = fstateObject.data[Object.keys(fstateObject.data)[0]];
              if (currentValue.includes(',')) {
                const fromValue = currentValue.split(',')[0];
                const toValue = currentValue.split(',')[1];
                const encodedDate = `${fromValue},${v}`;
                // ({currentValue, v, fromValue, toValue, encodedDate});
                return ({ id, name: x.name, data: { [currentOption]: encodedDate } })
              } else {
                const encodedDate = `,${v}`;
                // (currentValue, v, encodedDate)
                return ({ id, name: x.name, data: { [currentOption]: encodedDate } })
              }
            }
          }
        } else {
          return fstate.find(filter => filter.id === x.id);
        }

      })
      // (newState, 'am new state');
      return newState;
    });
  }

  const applyFilters = () => {
    setFilterTrue(true)

    const cleanedFilterState = isSelectedData.filter(x => {
      if (x.options) { // for select and radios
        return x.options.length > 0
      } else if (x.data) { // for date
        return x.data.greaterThan || x.data.lessThan || x.data.equalTo || x.data.lessThanEqual || x.data.greaterThanEqual || x.data.range
      } else if (x.value) { // for number type
        //x.value is a number u cant get length of it
        return (x.value.toString()).length > 0
      }
      // (x);
    });


    // localStorage.setItem("investmentFilter", JSON.stringify(cleanedFilterState));

    setAppliedFilter(cleanedFilterState);
    if (appliedFilter !== 0) {
      appliedFilter.map(x => {
        if (x.type === 'select' || x.type === 'radio') {
          const selectFilerobject = {
            id: x.id,
            options: [x.options],
            name: x.name,
          }
          isSelectedData.push(selectFilerobject);

        }
        else if (x.type === 'date' || x.type === 'number') {
          // var today = new Date(); 
          const emptyFilterObject = {
            id: x.id,
            data: {
              equalTo: ""
            },
            name: x.name,

          }
          isSelectedData.push(emptyFilterObject);
        }

      })
    }
    setIsFilterString(getFilterParams());

    // ("filter");
    // props.setOpen(false);
    setIsFilterOpen(false)
    // getData();

  }
  const shouldNameDisplay = (filter) => {
    // const exceptionCase = location.url
    return filter.showName ? filter.name : ""
  }

  // let conversionFormatFor_date={}

  const getFilterParams = () => {

    const conversionFormatFor_select = {
      "Country": "country_id",
      "Asset Class": "assetclass",
      "First Investment Date": "firstinvdt",
      "Investment Amount": "investedval",
      "Advised Amount": "advisedval",
      "Current Amount": "currentval",
      "Deviation": "deviation",
      "CAGR Return": "cagr",
      "Absolute Return": "gain",
      "Portfolio Return": "gainper",
      "Market Performance": "market_performance",
      "Alpha": "alpha",
    }
    // receiveid === 1 ?
    const conversionFormatFor_date = {
      "First Investment Date": "firstinvdt",
      "Investment Amount": "investedval",
      "Advised Amount": "advisedval",
      "Current Amount": "currentval",
      "Deviation": "deviation",
      "CAGR Return": "cagr",
      "Absolute Return": "gain",
      "Portfolio Return": "gainper",
      "Market Performance": "market_performance",
      "Alpha": "alpha"
    }
    // :
    //  conversionFormatFor_date = {      
    //   "First Investment Date":"firstinvdt",
    //   "Investment Amount":"investedval",
    //   "Advised Amount":"advisedval",
    //   "Current Amount":"currentval",
    //   "Deviation":"deviation",
    //   "CAGR Return":"cagr",
    //   "Absolute Return":"gain",
    //   "Portfolio Return":"gainper",
    //   "Market Performance":"market_performance",
    //   "Alpha":"alpha"
    // }
    const conversionFormatFor_number = {

    }

    const filterParams = {};

    appliedFilter.map(filter => {
      if (filter.options) { // condition it based on type of filter rather than options or data props

        filterParams[conversionFormatFor_select[filter.name]] = filter.options.map(x => x).join(',');
      } else if (filter.data) {
        let suffix;
        if (Object.keys(filter.data)[0] === 'greaterThan') {
          suffix = "__gt"
        } else if (Object.keys(filter.data)[0] === 'lessThan') {
          suffix = '__lt'
        } else if (Object.keys(filter.data)[0] === 'equalTo') {
          suffix = '';
        } else if (Object.keys(filter.data)[0] === 'lessThanEqual') {
          suffix = '__lte';
        } else if (Object.keys(filter.data)[0] === 'greaterThanEqual') {
          suffix = '__gte';
        } else if (Object.keys(filter.data)[0] === 'range') {
          suffix = '__range';
        }
        // (filter);
        // (Object.keys(filter.data)[0]);
        filterParams[conversionFormatFor_date[filter.name] + suffix] = filter.data[Object.keys(filter.data)[0]];
      }
      // else if(filter.value){
      //     filterParams[conversionFormatFor_number[filter.name]] = filter.value;
      // }
    })
    //return the query string with the filterParams
    // (("&"+Object.keys(filterParams).map(x=>x+"="+filterParams[x]).join('&')));
    const params = Object.keys(filterParams).map(x => x + "=" + filterParams[x]).join('&')
    return (params ? "&" + params : "");
    // (receiveid === 1 ? (params ? "&" + params : "") : params);    
    // return params;
  }


  const clearFilters = () => {
    setIsSelectedDatas([
      {
        id: 1,
        data: { equalTo: "" },
        name: "First Investment Date",

      },
      {
        id: 2,
        options: [],
        name: "Country",

      },
      {
        id: 3,
        options: [],
        name: "Asset Class",
      },
      {
        id: 4,
        data: { equalTo: "" },
        name: 'Investment Amount',
      },
      {
        id: 5,
        data: { equalTo: "" },
        name: 'Advised Amount',
      },
      {
        id: 6,
        data: { equalTo: "" },
        name: 'Current Amount',
      },
      {
        id: 7,
        data: { equalTo: "" },
        name: 'Deviation',
      },
      {
        id: 8,
        data: { equalTo: "" },
        name: 'CAGR Return',
      },
      {
        id: 9,
        data: { equalTo: "" },
        name: 'Absolute Return',
      },
      {
        id: 10,
        data: { equalTo: "" },
        name: 'Portfolio Return',
      },
      {
        id: 11,
        data: { equalTo: "" },
        name: 'Market Performance',
      },
      {
        id: 12,
        data: { equalTo: "" },
        name: 'Alpha',
      },
    ])
    localStorage.removeItem("selectedinvestorfiltersdata");
    localStorage.removeItem("investmentFilter")
  }
  // (columns);
  const parseRangeValue = (doubleDate, fromTo) => {
    if (fromTo === 'from') {
      return doubleDate.split(',')[0];
    } else {
      return doubleDate.split(',')[1];
    }
  }


  let nameval = "";
  let useridval = "";

  const gotoMisSalaesReportsCards = () => {
    history.push({
      pathname: viewMitsReportsPath,
      state: receiveid
    })
  }

  return (
    <>
      <Paper className={classes.root}>
        <div className="prospectsearchfilterboth">
          <Button
            variant="outlined"
            color="default"
            startIcon={<ArrowBackIosIcon />}
            onClick={gotoMisSalaesReportsCards}
          >
            Back
          </Button>
          <div className="prospectsearch">
            <SearchBar
              value={searched}
              onChange={(searchVal) => requestSearch(searchVal)}
              onCancelSearch={(searchVal) => cancelSearch(searchVal)}
            // className={"mt30"}
            // style={{border:'3px solid blue', width:'10rem'}}
            />
            <Button
              variant="outlined"
              color="primary"
              style={{ marginLeft: '10px' }}
              startIcon={<SearchIcon />}
              onClick={requestSearching}
            >
              Search
            </Button>
          </div>

          <div>
            <div>
              {/* <tab />   // Need To Comment This           */}
              <TablePagination
                rowsPerPageOptions={[10, 50, 100, 500]}
                component="div"
                count={orignalRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              // style={{width:'27rem'}}
              />
            </div>
          </div>

          <div
            style={{ display: "flex", position: "relative" }}
            className="tfilter"
          >
            Filter
            <div>
              <span style={{ margin: "0px 15px", display: "inline-block" }}>

              </span>
              <SvgIcon
                style={{ cursor: "pointer", verticalAlign: "middle" }}
                onClick={openFilter}
                title={"filter"}
              >
                <FilterLogo />
              </SvgIcon>
              <Filter
                data={passData}
                setOpen={handleMenuClose}
                isMenuOpen={isMenuOpen}
                style={{ border: "3px solid black" }}
              />
              {
                isFilterOpen ? (
                  <div
                    className={["newfilterstyle", "menupopupfilter", "filter"].join(" ")}

                  >
                    {/* {('am fun', isSelectedData)} */}
                    <div
                      style={{ width: 30, height: 30, borderRadius: '50%', lineHeight: '30px', display: 'flex', justifyContent: 'center', fontWeight: 'bold', cursor: 'pointer', background: '#ddd', margin: '5px 0 0 5px' }}

                      onClick={closeFilter}
                    >
                      X
                    </div>
                    {
                      isFilterData.map((filter, index) => {
                        return (<div key={index} style={{ marginLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                          <div>
                            <InputLabel style={{ color: "black" }} >{shouldNameDisplay(filter)}</InputLabel>
                          </div>
                          {/* {isSelectedData.map((es) => {
                          return (
                            <>
                              {es.sno} am state
                            </>
                          )
                        })} */}


                          <div style={{ paddingTop: 10 }}>
                            {
                              filter.type === "select" && filter.showName == true ?
                                <>
                                  <Select
                                    labelId="mutiple-select-label"
                                    displayEmpty
                                    className="select"
                                    variant='outlined'
                                    multiple
                                    value={isSelectedData.find(x => { return x.id === filter.id })?.options || []}
                                    name={filter.name}

                                    onChange={e => { handleSelectChange(e.target.value, filter.id) }}
                                    // renderValue={(selectedDatas) => selectedDatas.join(", ")}
                                    renderValue={
                                      (selected) => {
                                        return (
                                          selected.map(s => filter.options.find(x => x.value === s)?.name).join(', ')
                                        )
                                      }
                                    }

                                  // MenuProps={MenuProps}
                                  >

                                    {filter.options.map((option, index) => (
                                      <MenuItem key={index} value={option.value}>
                                        <ListItemText primary={option.name} />
                                        <ListItemIcon >
                                          <Checkbox
                                            classes={{ root: classes.radio, checked: classes.checked }}
                                            checked={isSelectedData.find(x => x.id === filter.id)?.options.indexOf(option.value) !== -1 ? true : false}

                                          />
                                        </ListItemIcon>
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </> :
                                filter.type === "radio" && filter.showName == true ?
                                  <>
                                    <Select
                                      displayEmpty
                                      value={isSelectedData.find(x => { return x.id === filter.id })?.options}
                                      onChange={e => { handleSelectChange(e.target.value, filter.id) }}
                                      name={filter.name}
                                      className="select"
                                      variant='outlined'
                                      multiple
                                      style={{
                                        backgroundColor: "white"
                                      }}
                                    >
                                      <MenuItem value="">Select</MenuItem>
                                      {
                                        filter.options.map((option, index) => {
                                          return (
                                            <MenuItem key={index} value={option.value}>
                                              <ListItemText primary={option.name} />
                                            </MenuItem>
                                          )

                                        })
                                      }
                                    </Select>
                                  </> :
                                  filter.type === "date" && filter.showName == true ?
                                    <>
                                      <select
                                        value={Object.keys(isSelectedData.find(x => { return x.id === filter.id })?.data || {})[0]}
                                        onChange={x => handleSelectChange(x.target.value, filter.id, "option")}
                                        className="select"
                                        label={filter.name}
                                        style={{
                                          backgroundColor: "white",
                                          marginBottom: 10
                                        }}
                                      >
                                        <option value={"equalTo"} >Equal To</option>
                                        <option value={"lessThan"} >Less Than</option>
                                        <option value={"greaterThan"} >Greater Than</option>
                                        <option value={"lessThanEqual"} >Less Than Equal To</option>
                                        <option value={"greaterThanEqual"} >Greater Than Equal To</option>
                                        <option value={"range"} >Range</option>

                                      </select>
                                      {
                                        Object.keys(isSelectedData.find(x => { return x.id === filter.id })?.data || {})[0] !== 'range' ?
                                          (
                                            <TextField
                                              type="date"
                                              variant="outlined"
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                              value={isSelectedData.find(x => x.id === filter.id)?.data[Object.keys(isSelectedData.find(x => x.id === filter.id)?.data || {})[0]]}
                                              onChange={x => handleSelectChange(x.target.value, filter.id, "value")}
                                              className="select"
                                              style={{
                                                backgroundColor: "white"
                                              }}
                                            />


                                          ) :
                                          // RANGE FIELDS
                                          (
                                            <>
                                              <label style={{ fontSize: 11, marginBorrom: 10, display: 'block' }}> From </label>
                                              <TextField
                                                type="date"
                                                variant="outlined"
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                value={parseRangeValue(isSelectedData.find(x => x.id === filter.id)?.data[Object.keys(isSelectedData.find(x => x.id === filter.id)?.data || {})[0]], 'from')}
                                                onChange={x => handleSelectChange(x.target.value, filter.id, "rangeFrom")}
                                                className="select"
                                                style={{
                                                  backgroundColor: "white"
                                                }}
                                              />
                                              <label style={{ fontSize: 11, marginBorrom: 10, display: 'block' }}> To </label>
                                              <TextField
                                                type="date"
                                                variant="outlined"
                                                InputLabelProps={{
                                                  shrink: true,

                                                }}
                                                value={parseRangeValue(isSelectedData.find(x => x.id === filter.id)?.data[Object.keys(isSelectedData.find(x => x.id === filter.id)?.data || {})[0]], 'to')}
                                                onChange={x => handleSelectChange(x.target.value, filter.id, "rangeTo")}
                                                className="select"
                                                style={{
                                                  backgroundColor: "white"
                                                }}
                                              />
                                            </>
                                          )
                                      }
                                    </> :
                                    filter.type === "number" && filter.showName == true ?
                                      <>
                                        <select
                                          value={Object.keys(isSelectedData.find(x => { return x.id === filter.id })?.data || {})[0]}
                                          onChange={x => handleSelectChange(x.target.value, filter.id, "option")}
                                          className="select"
                                          label={filter.name}
                                          style={{
                                            backgroundColor: "white",
                                            marginBottom: 10
                                          }}
                                        >
                                          <option value={"equalTo"} >Equal To</option>
                                          <option value={"lessThan"} >Less Than</option>
                                          <option value={"greaterThan"} >Greater Than</option>
                                          <option value={"lessThanEqual"} >Less Than Equal To</option>
                                          <option value={"greaterThanEqual"} >Greater Than Equal To</option>
                                          <option value={"range"} >Range</option>

                                        </select>
                                        {/* {// ('test1', filter.id)}
                  {// (filterState.find(x=>{// (x);return x.id===filter.id}))}
                  {// ('test2')} */}
                                        {
                                          Object.keys(isSelectedData.find(x => { return x.id === filter.id })?.data || {})[0] !== 'range' ?
                                            (
                                              <TextField
                                                type="text"
                                                variant="outlined"
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                value={isSelectedData.find(x => x.id === filter.id)?.data[Object.keys(isSelectedData.find(x => x.id === filter.id)?.data || {})[0]]}
                                                onChange={x => handleSelectChange(x.target.value, filter.id, "value")}
                                                className="select"
                                                style={{
                                                  backgroundColor: "white"
                                                }}
                                              />

                                            ) :
                                            // RANGE FIELDS
                                            (
                                              <>
                                                <label style={{ fontSize: 11, marginBorrom: 10, display: 'block' }}> From </label>
                                                <TextField
                                                  type="text"
                                                  variant="outlined"
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  value={parseRangeValue(isSelectedData.find(x => x.id === filter.id)?.data[Object.keys(isSelectedData.find(x => x.id === filter.id)?.data || {})[0]], 'from')}
                                                  onChange={x => handleSelectChange(x.target.value, filter.id, "rangeFrom")}
                                                  className="select"
                                                  style={{
                                                    backgroundColor: "white"
                                                  }}
                                                />
                                                <label style={{ fontSize: 11, marginBorrom: 10, display: 'block' }}> To </label>
                                                <TextField
                                                  type="text"
                                                  variant="outlined"
                                                  InputLabelProps={{
                                                    shrink: true,

                                                  }}
                                                  value={parseRangeValue(isSelectedData.find(x => x.id === filter.id)?.data[Object.keys(isSelectedData.find(x => x.id === filter.id)?.data || {})[0]], 'to')}
                                                  onChange={x => handleSelectChange(x.target.value, filter.id, "rangeTo")}
                                                  className="select"
                                                  style={{
                                                    backgroundColor: "white"
                                                  }}
                                                />
                                              </>
                                            )
                                        }
                                      </>

                                      : ""
                            }

                          </div>
                        </div>
                        )
                      })}
                    <div style={{ float: "right", paddingBottom: 10, paddingRight: 40, paddingTop: 10, display: "flex", justifyContent: "flex-end", columnGap: 20 }}>
                      <Button variant='contained' onClick={clearFilters} color="default">Clear</Button>
                      <Button variant='contained' onClick={applyFilters} color="primary">Apply</Button>
                    </div>

                  </div>
                ) :
                  ""

              }
            </div>
          </div>
        </div>


        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {/* {columns.map(item => {
                                    return (
                                        <TableCell>{item.headerName}</TableCell>
                                    )
                                })} */}
                {columns.map((column, index) => (
                  <TableCell
                    key={index}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className='prospect_table'

                  >
                    <TableSortLabel
                      active={orderBy === column.index}
                      direction={orderBy === column.index ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.index, column.format)
                      }
                    >
                      {column.headerName}
                    </TableSortLabel>
                  </TableCell>
                ))}

              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length !== 0 ?
                <>
                  {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                    return (
                      <TableRow>
                        {
                          columns.map((column, index) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                key={index}
                                align={column.align}
                                style={{
                                  padding: value === 0 ? '18px' : '18px',
                                  // textAlign: 'center'
                                  cursor: 'pointer'


                                }}
                                // style={{
                                // value? {'padding:'18px' }: {""}}}

                                onDoubleClick={() => viewProspectDetails(row)}
                              >
                                {
                                  column.format && typeof value === "number" ? (
                                    column.format(value)
                                  ) : column.id === "type" && value.length !== 0 ? (
                                    <>

                                      {Array.isArray(value) ? value.join(',') : "N/A"}


                                    </>
                                  ) : column.type === "Date" ? (
                                    getDateTime(value)
                                  ) : column.operation &&
                                    column.operation === "concate" ? (
                                    value + column.operand + row[column.with]
                                  ) : column.type &&
                                    column.type === "link" &&
                                    value ? (
                                    <p
                                      style={{
                                        margin: '0px', padding: '18px',
                                        textAlign: 'center',
                                        cursor: 'pointer'
                                      }}
                                      variant="body2"
                                      // onClick={(e) => viewDetails(row)}
                                      // onClick={(e) => viewProspectDetails(row.weekNo, row.weekCount)}
                                      onClick={(e) => viewProspectDetails(row)}

                                      gutterBottom
                                    // style={{ cursor: "pointer", color: "black", textDecoration: 'none' }}
                                    >

                                      {value}
                                    </p>
                                  ) : column.type &&
                                    column.type === "attach" &&
                                    value ? (
                                    <Link
                                      // href={staticFiles + value}
                                      target="_blank"
                                      variant="body2"
                                      gutterBottom
                                      style={{ cursor: "pointer" }}
                                    >
                                      {value}
                                    </Link>
                                  ) : (column.type &&
                                    column.type === "decimal") ?
                                    value
                                    :

                                    (

                                      value === null ? (
                                        <div style={{ padding: '18px' }}>
                                          N/A
                                        </div>
                                      ) : value
                                    )

                                }


                              </TableCell>
                            );
                          })
                        }
                      </TableRow>
                    )
                  })}
                </>
                :
                <TableRow>
                  <TableCell colspan="9" style={{ "text-align": "center", margin: "10px 0px" }}>
                    No Data Available...
                  </TableCell>
                </TableRow>
              }
            </TableBody>
          </Table>
        </TableContainer>

        <div>
          {/* <tab />   // Need To Comment This           */}
          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 500]}
            component="div"
            count={orignalRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          // style={{width:'27rem'}}
          />
        </div>
      </Paper>
    </>
  );
}
export default ViewChildMitReports;
